import { create } from 'zustand';
import { produce } from 'immer';

export interface TabSlice {
  activeTab: string;
  setActiveTab: (activeTab: string) => void;
}

const useTabStore = create<TabSlice>((set) => ({
    activeTab: 'tracking',
    setActiveTab: (activeTab) =>
    set(
      produce((state: TabSlice) => {
        state.activeTab = activeTab;
      })
    ),
}));

export default useTabStore;
